import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { KitchenCard } from "@/components/KitchenCard";
import { US_STATES } from "@/lib/usStates";
import api from "@/lib/api";

export default function StateLanding() {
  const { stateCode } = useParams();
  const code = (stateCode || "").toUpperCase();
  const stateInfo = US_STATES.find((s) => s.code === code);
  const [items, setItems] = useState([]);
  const [trends, setTrends] = useState(null);

  useEffect(() => {
    document.title = `Commercial kitchens in ${stateInfo?.name || code} · KitchenShare`;
    api.get("/kitchens", { params: { state: code } }).then((r) => setItems(r.data));
    api.get("/trends/amenities", { params: { state: code } }).then((r) => setTrends(r.data));
  }, [code, stateInfo]);

  return (
    <div className="min-h-screen">
      <Navbar />
      <div className="max-w-7xl mx-auto px-6 py-14">
        <div className="tick-label">State directory</div>
        <h1 className="font-display font-black text-5xl lg:text-6xl tracking-tighter mt-2">
          Kitchens in {stateInfo?.name || code}.
        </h1>
        <p className="text-neutral-400 mt-3 max-w-2xl">
          Rent a licensed commercial kitchen by the hour anywhere in {stateInfo?.name || code}. Approved cooks, food handler license required, 15% platform fee — same as every other state.
        </p>

        {trends && trends.top.length > 0 && (
          <div className="mt-8 border hairline p-5">
            <div className="tick-label">Most-equipped amenities in {stateInfo?.name || code}</div>
            <div className="mt-3 flex flex-wrap gap-2">
              {trends.top.slice(0, 8).map((t) => (
                <span key={t.amenity} className="border hairline px-3 py-1.5 text-sm">
                  {t.amenity} <span className="text-neutral-500 font-mono">· {t.count}</span>
                </span>
              ))}
            </div>
          </div>
        )}

        <div className="mt-10">
          {items.length === 0 ? (
            <div className="border hairline p-10 text-center">
              <div className="font-display text-2xl font-bold">No kitchens listed yet in {stateInfo?.name || code}.</div>
              <Link to="/list-your-kitchen" className="btn-signal inline-block mt-4">Be the first — list yours</Link>
            </div>
          ) : (
            <div data-testid="state-kitchen-grid" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {items.map((k) => <KitchenCard key={k.id} k={k} />)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
